import _classCallCheck from "/drone/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/drone/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import * as UsersMedia from "./media/users";
import * as TracksMedia from "./media/tracks";
import * as SparksMedia from "./media/sparks";
import { truncate } from "./strings";
import { endpoints } from "./config";
import { colors } from "../../components/styles/variables";
import { translate } from "./i18n";
import DateUtils from "./date";
import { publicStaticPath } from "../../shared/constants/Image";
var LayoutProps = /*#__PURE__*/function () {
  function LayoutProps() {
    _classCallCheck(this, LayoutProps);
  }
  _createClass(LayoutProps, null, [{
    key: "default",
    value: function _default() {
      return {};
    }
  }, {
    key: "donation",
    value: function donation(_ref) {
      var user = _ref.user;
      if (!user) return LayoutProps.default();
      var strOptions = {
        name: user.name,
        username: user.userName
      };
      return {
        title: translate('donation.title', strOptions),
        description: translate('donation.description', strOptions),
        image: user.hasImage ? UsersMedia.getImage(user.id, 210) : null,
        og: {
          type: 'profile',
          author: user.name
        }
      };
    }
  }, {
    key: "profile",
    value: function profile(_ref2) {
      var user = _ref2.user;
      if (!user) return LayoutProps.default();
      var baseTitle = "".concat(user.name, " (@").concat(user.userName, ")");
      var strOptions = {
        name: user.name,
        username: user.userName,
        likes: user.likesCount,
        posts: user.postsCount,
        tracks: user.collectionsCount
      };
      return {
        title: "".concat(baseTitle, " \u2022 Hotmart Sparkle"),
        description: translate('profile.description', strOptions),
        image: user.hasImage ? UsersMedia.getImage(user.id, 210) : null,
        og: {
          type: 'profile',
          title: truncate(baseTitle, 100),
          abstract: user.bio,
          description: user.bio,
          author: user.name
        }
      };
    }
  }, {
    key: "spark",
    value: function spark(_ref3) {
      var _spark = _ref3.spark;
      if (!_spark) return LayoutProps.default();
      var title = _spark.custom ? _spark.custom.title_detail : _spark.title;
      var strOptions = {
        author: _spark.authorName,
        comments: _spark.commentsCount,
        date: DateUtils.formatByLength(_spark.pubDate, 'date', 'long'),
        likes: _spark.likesCount,
        title: truncate(title, 50),
        username: _spark.authorUserName
      };
      var description = _spark.custom && _spark.custom.title_card;
      return {
        title: "".concat(truncate(title, 50), " \u2022 @").concat(strOptions.username, " \u2022 Hotmart Sparkle"),
        description: description || translate('spark.description', strOptions),
        image: _spark.hasSnapshot ? SparksMedia.getSnapshotBySize(_spark.id, false, 'md') : null,
        og: {
          type: 'article',
          title: truncate(title, 100),
          abstract: _spark.content || description,
          description: _spark.content || description,
          author: _spark.authorName
        }
      };
    }
  }, {
    key: "track",
    value: function track(_ref4) {
      var _track = _ref4.track;
      if (!_track) return LayoutProps.default();
      var strOptions = {
        name: _track.name,
        likes: _track.likesCount,
        posts: _track.size,
        owner: _track.owner,
        ownerUserName: _track.ownerUserName
      };
      var isCollaborative = _track.isCollaborative;
      var hasImage = _track.imageURL || _track.image;
      var baseTitle = "".concat(translate('tracks.word', {
        context: isCollaborative ? 'collaborative' : ''
      }), " \"").concat(_track.name, "\"");
      return {
        title: "".concat(baseTitle, " \u2022 ").concat(_track.size, " Sparks \u2022 Hotmart Sparkle"),
        description: translate('tracks.description', strOptions),
        image: hasImage ? TracksMedia.getMedia(_track.id, false, 210) : null,
        og: {
          type: 'profile',
          title: truncate(baseTitle, 100),
          description: _track.description,
          abstract: _track.description,
          author: _track.owner
        }
      };
    }
  }, {
    key: "trending",
    value: function trending() {
      return {
        title: translate('trending.title'),
        description: translate('trending.description'),
        og: {
          title: translate('trending.title'),
          description: translate('trending.description')
        }
      };
    }
  }, {
    key: "parseProps",
    value: function parseProps(props) {
      var imgDefault = "".concat(endpoints.APP).concat(publicStaticPath, "/images/og-image.png");
      var image = props.image,
        _props$og = props.og,
        og = _props$og === void 0 ? {} : _props$og,
        title = props.title,
        keywords = props.keywords,
        description = props.description;
      return {
        title: title || translate('seo.title'),
        description: og.description || description || translate('seo.description'),
        keywords: keywords || translate('seo.keywords'),
        color: colors.white,
        og: {
          type: og.type || 'website',
          title: og.title || title || translate('seo.og.title'),
          description: og.description || description || translate('seo.og.description'),
          image: image || imgDefault,
          author: og.author || og.authorName || description
        }
      };
    }
  }, {
    key: "get",
    value: function get() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fn = this[page];
      var props = fn ? fn(data) : this.default;
      return this.parseProps(props);
    }
  }]);
  return LayoutProps;
}();
export { LayoutProps as default };